export default __webpack_public_path__ + "static/media/Online.df39cae2.jpg";